module.exports = __webpack_public_path__ + "static/media/icon-supplies-waterflosser.2403de37.svg";